import React, { useEffect, useState } from "react";
import axios from "axios";
import AddSnapVariant from "./sql/AddSnapVariant.jsx";
import UpdateSnapVariant from "./sql/UpdateSnapVariant.jsx";
import DeleteSnapVariant from "./sql/DeleteSnapVariant.jsx";
import "../App.css";

function MyVariants({ user }) {
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [showAddPanel, setShowAddPanel] = useState(false);
  const [selectedUpdate, setSelectedUpdate] = useState(null);
  const [updatedVariant, setUpdatedVariant] = useState({});
  const [selectedDelete, setSelectedDelete] = useState(null);

  const [sort, setSort] = useState("date");

  const fetchVariants = async (sortOption, userId) => {
    if (!userId) return;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/data/snapVariants`,
        { params: { sort: sortOption, userId } }
      );
      setVariants(res.data || []);
    } catch (err) {
      console.error("Failed to fetch variants:", err);
      setVariants([]);
    }
  };

  useEffect(() => {
    if (user?.id) fetchVariants(sort, user.id);
  }, [sort, user?.id]);

  if (!user?.id) {
    return (
      <div style={{ textAlign: "center", marginTop: 24 }}>
        <h2 className="main-title">Upcoming Variants</h2>
        <p style={{ color: "#bbb" }}>Sign in to view your assigned variants.</p>
      </div>
    );
  }

  return (
    <>
      <div>
        <h1 className="main-title" style={{ textAlign: "center" }}>
          Upcoming Variants
        </h1>
        <br /><br /><br /><br /><br />
      </div>

      <div style={{ textAlign: "center", marginBottom: "16px" }}>
        <label style={{ color: "#ccc", marginRight: "8px" }}>Sort by:</label>
        <select
          className="input"
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          style={{ maxWidth: "200px" }}
        >
          <option value="date">Release Date</option>
          <option value="chance">Chance of Getting</option>
          <option value="name">Name</option>
        </select>

        <button className="button" onClick={() => setShowAddPanel(true)}>
          Add Variant
        </button>
      </div>

      <div className="list-container">
        <div
          className="card-grid"
          style={{ gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))" }}
        >
          {variants.map((item) => (
            <div
              key={item.id}
              style={{
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: "10px",
                padding: "10px",
                textAlign: "center",
                cursor: "pointer",
              }}
              onClick={() => setSelectedVariant(item)}
            >
              <img
                src={item.cardhtml}
                alt={item.cardName}
                style={{ width: "100%", borderRadius: "8px", marginBottom: "8px" }}
              />
              {item.releasedate ? (
                <div style={{ fontSize: "0.8rem", color: "#aaa" }}>
                  Release: {new Date(item.releasedate).toLocaleDateString()}
                </div>
              ) : (
                <div style={{ fontSize: "0.8rem", color: "#aaa" }}>Release: Unknown</div>
              )}
              <div style={{ fontSize: "0.8rem", color: "#aaa" }}>
                Chance: {item.chanceofgetting}%
              </div>
              <button
                className="button"
                style={{ marginTop: "6px", fontSize: "0.8rem" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedUpdate(item);
                }}
              >
                Update
              </button>
              <button
                className="button"
                style={{ marginTop: "6px", fontSize: "0.8rem", background: "#a33" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedDelete(item);
                }}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Details Modal */}
      {selectedVariant && (
        <div className="modal-overlay" onClick={() => setSelectedVariant(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2 className="modal-title" style={{ textAlign: "center", marginBottom: "16px" }}>
              {selectedVariant.cardname} Variant
            </h2>

            <div style={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
              <img
                src={selectedVariant.cardhtml}
                alt={selectedVariant.cardname}
                className="modal-card-image"
                style={{
                  maxWidth: "300px",
                  borderRadius: "10px",
                  boxShadow: "0 0 10px rgba(255, 215, 0, 0.3)",
                }}
              />
            </div>

            {selectedVariant.carddesc && (
              <p
                style={{
                  color: "#ddd",
                  textAlign: "center",
                  fontSize: "1rem",
                  marginBottom: "16px",
                }}
              >
                {selectedVariant.carddesc}
              </p>
            )}

            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button className="button" onClick={() => setSelectedVariant(null)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showAddPanel && (
        <div className="modal-overlay" onClick={() => setShowAddPanel(false)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "500px", background: "#111" }}
          >
            {/* pass user so new items attach to user */}
            <AddSnapVariant
              setData={setVariants}
              route={`${process.env.REACT_APP_API_URL}api/addSnapVariant`}
              userId={user.id}
              onSaved={() => fetchVariants(sort, user.id)}
            />
            <div style={{ textAlign: "center", marginTop: "16px" }}>
              <button className="button" onClick={() => setShowAddPanel(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {selectedUpdate && (
        <div className="modal-overlay" onClick={() => setSelectedUpdate(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "500px", background: "#111" }}
          >
            <UpdateSnapVariant
              selectedVariant={selectedUpdate}
              updatedVariant={updatedVariant}
              setUpdatedVariant={setUpdatedVariant}
              userId={user.id}
              onSaved={() => fetchVariants(sort, user.id)}
              onClose={() => setSelectedUpdate(null)}
            />
            <div style={{ textAlign: "center", marginTop: "16px" }}>
              <button className="button" onClick={() => setSelectedUpdate(null)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {selectedDelete && (
        <div className="modal-overlay" onClick={() => setSelectedDelete(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "400px", background: "#111" }}
          >
            <DeleteSnapVariant
              selectedVariant={selectedDelete}
              setSelectedVariant={setSelectedDelete}
              setData={setVariants}
              onDeleted={() => fetchVariants(sort, user.id)}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default MyVariants;
